<script>
  // Done-trail tally for group headers (spec §5). Renders the given parts
  // joined by dots, hiding nothing itself — parents pre-filter zero counts —
  // plus a check icon once the group is done.
  export let parts = []; // [{text, kind: 'info' | 'good' | 'muted' | 'warn'}]
  export let done = false;
</script>

<span class="tally">
  {#if done}
    <!-- span wrapper: Font Awesome's dom.watch() replaces bare <i> nodes, which
         crashes Svelte teardown when the <i> is the top level of a block -->
    <span class="check"><i class="fas fa-check-circle" /></span>
  {/if}
  {#each parts as p, i}
    {#if i > 0}<span class="sep">·</span>{/if}
    <span class={p.kind}>{p.text}</span>
  {/each}
</span>

<style>
  .tally {
    margin-left: auto;
    display: inline-flex;
    align-items: center;
    gap: 0.35rem;
    font-size: 0.8rem;
    white-space: nowrap;
  }
  .check {
    color: #198754;
  }
  /* transfer segment: blue, so it never reads as a status change */
  .info {
    color: #0b5ed7;
  }
  .good {
    color: #198754;
  }
  .muted {
    color: #6c757d;
  }
  .warn {
    color: #b45309;
    font-weight: 600;
  }
  .sep {
    color: #adb5bd;
  }
</style>
